import React from "react";
import PropTypes from "prop-types";
import styles from "./EditableHeading.module.scss"; // Import css modules stylesheet as styles

export class EditableHeading extends React.Component {
  render() {
    return (
      <div>
        <input
          className={styles.heading}
          value={this.props.value}
          onChange={this.props.onChange}
        />
      </div>
    );
  }
}

EditableHeading.propTypes = {
  title: PropTypes.string
};
